import { Spinner } from '@components/ui/Primitives'
import React from 'react'

export const AppSplash: React.FC = () => {
  return <Spinner />
}

export default AppSplash
